import { render, staticRenderFns } from "./TheAside.vue?vue&type=template&id=69c4dace&scoped=true&"
import script from "./TheAside.vue?vue&type=script&lang=js&"
export * from "./TheAside.vue?vue&type=script&lang=js&"
import style0 from "./TheAside.vue?vue&type=style&index=0&id=69c4dace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c4dace",
  null
  
)

export default component.exports